import { render } from "./dentrion_contact.vue?vue&type=template&id=a34403e4&scoped=true"
import script from "./dentrion_contact.vue?vue&type=script&lang=js"
export * from "./dentrion_contact.vue?vue&type=script&lang=js"

import "./dentrion_contact.vue?vue&type=style&index=0&id=a34403e4&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a34403e4"]])

export default __exports__